export default __webpack_public_path__ + "static/ProValue_4@768-a69588fc4f25fe8f568536838530590b.png";